
//custom js starts here

// $(document).on('click', '.color-swatch__item, .block-swatch__item', function(){
//   var new_val = $(this).attr('data-name');
//   $(this).parents('.product-form__option').find('.product-form__option-name .product-form__selected-value-custom-text-append').text(new_val);
//   setTimeout(function(){ 
//     //   var h = $(this).parents('.color-swatch').find('input').val();
//     //   console.log(h);
//     //   var new_html = h.replace(/_/g, " ");
//     //   $('.product-form__selected-value1').text(new_html);
//     //   var html_text = $(this).parents('.product-form__option').find('.product-form__selected-value').text();
//     //   console.log(html_text);
//     //   var new_val = html_text.replace(/_/g," ");
//     // console.log(new_val);
//     jQuery.ajax({
//       type: 'GET',
//       url: window.location.href,
//       dataType: 'html',
//       success: function(data){
//         $('.product-block-list__item--gallery-alt-based').html($(data).find('.product-block-list__item--gallery-alt-based').html());
//         $('.thumnil-slider-product-page').show();
//         $('.custom-slider-main').show();
//         $('.custom-slider-main').slick({
//           infinite: false,
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           arrows:false,
//           speed: 500,
//           dots: false,
//           asNavFor: '.thumnil-slider-product-page'
//         });
//         if($( window ).width()>1000){
//           $('.thumnil-slider-product-page').slick({
//             infinite: false,
//             vertical: true,
//             slidesToShow: 5,
//             slidesToScroll: 1,
//             asNavFor: '.slider-for',
//             focusOnSelect: true,
//             arrows:false,
//             verticalSwiping:true,
//             asNavFor: '.custom-slider-main',
//             responsive: [
//               {
//                 breakpoint: 1000,
//                 settings: {
//                   vertical: false,
//                   slidesToShow: 5
//                 }
//               },
//               {
//                 breakpoint: 767,
//                 settings: {
//                   slidesToShow: 4
//                 }
//               }
//             ]
//           });
//         }else{
//           $('.thumnil-slider-product-page').slick({
//             infinite: true,
//             vertical: false,
//             slidesToShow: 4,
//             slidesToScroll: 1,
//             asNavFor: '.slider-for',
//             focusOnSelect: true,
//             arrows:false,
//             asNavFor: '.custom-slider-main'
//           });
//         }
//         var zoomid = $('.custom-slider-main .slick-current.product-gallery__carousel-item').attr('id');
//         $("#"+zoomid).ezPlus();
//         $('.custom-slider-main').on('afterChange', function(event, slick, currentSlide, nextSlide){
//           $.removeData($('img'), 'elevateZoom');
//           $('.zoomContainer').remove();
//           var zoomid = $('.custom-slider-main .slick-current.product-gallery__carousel-item').attr('id');
//           $("#"+zoomid).ezPlus();
//         });
//       },
//       error: function(data){
//         console.log('error');
//       }
//     });
//   }, 300);
// });
// $(document).ready(function(){
//   var zoomid = $('.custom-slider-main .slick-current.product-gallery__carousel-item').attr('id');
//   $("#"+zoomid).ezPlus();
//   $('.custom-slider-main').on('afterChange', function(event, slick, currentSlide, nextSlide){
//     $.removeData($('img'), 'elevateZoom');
//     $('.zoomContainer').remove();
//     var zoomid = $('.custom-slider-main .slick-current.product-gallery__carousel-item').attr('id');
//     $("#"+zoomid).ezPlus();
//   });
// });

$(document).ready(function() {

$('.save-with-sets-section .product-list22').slick({
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  dots: false,
  arrows: true,
  prevArrow: `
    <button type="button" class="slick-prev custom-arrow">
      <svg class="icon icon--arrow-minimal-previous" aria-hidden="true" focusable="false" role="presentation" width="7" height="9" viewBox="0 0 7 9">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.07 8.6c-.3.3-.77.3-1.06 0L.94 4.54 5.01.47a.75.75 0 1 1 1.06 1.06l-3 3 3 3.01c.29.3.29.77 0 1.06Z"></path>
      </svg>
    </button>
  `,
  nextArrow: `
    <button type="button" class="slick-next custom-arrow">
      <svg class="icon icon--arrow-minimal-next" aria-hidden="true" focusable="false" role="presentation" width="7" height="9" viewBox="0 0 7 9">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M.93 8.6c.3.3.77.3 1.06 0l4.07-4.06L1.99.47A.75.75 0 1 0 .93 1.53l3 3-3 3.01c-.29.3-.29.77 0 1.06Z"></path>
      </svg>
    </button>
  `,
  responsive: [
    {
      breakpoint: 1024, // tablet
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 768, // mobile
      settings: {
        slidesToShow: 1,   // fractional slide
        slidesToScroll: 1,
        infinite: false,     // optional for mobile
        dots: true           // easier navigation on mobile
      }
    }
  ]
});


        
  //toggle the component with class accordion_body
  $(document).on('click','.accordion_head', function(e){
        e.preventDefault();
    //     console.log('click custom');
    if ($(this).parent('.accordion_container').hasClass('active')) {
       $(this).parent('.accordion_container').removeClass('active');
      $(this).parent('.accordion_container').find('.accordion_body').slideUp(200);
      $(this).children(".plusminus").text('+');
    }else{
      // $('.accordion_container').removeClass('active');
      // $('.accordion_container').find('.accordion_body').slideUp(200);
      // $('.accordion_head').children(".plusminus").text('+');

      
      $(this).parent('.accordion_container').addClass('active');
      $(this).parent('.accordion_container').find('.accordion_body').slideDown(200);
      $(this).children(".plusminus").text('-');
    }
    // if ($('.accordion_container .accordion_body').is(':visible')) {
    //   $(".accordion_container .accordion_body").slideUp();
    //   $(".plusminus").text('+');
    // }

    // if ($(this).next(".accordion_container .accordion_body").is(':visible')) {
    //   $(this).next(".accordion_container .accordion_body").slideUp();
    //   $(this).children(".plusminus").text('+');
    //   $(".accordion_container .gift_heading").show();
    //   var id = $(this).attr('id');
    //   setTimeout(function(){
    //     $('html, body').animate({
    //       // scrollTop: $("#"+id).offset().top - 200
    //     }, 2000);
    //   }, 1000);
    // } else {
    //   $(this).next(".accordion_container .accordion_body").slideDown();
    //   $(this).children(".plusminus").text('-');
    //   $(this).find(".accordion_container .gift_heading").hide();
    //   var id = $(this).attr('id');
    //   setTimeout(function(){
    //     $('html, body').animate({
    //       // scrollTop: $("#"+id).offset().top - 200
    //     }, 2000);
    //   }, 1000);
    // }


  });
});

// // $(document).on('click','.offer-product-addtocart',function(){
// //   $('.offer-product-addtocart').addClass('prosecing-request');

// //   var get_id = $(this).data('id');
// //   jQuery.ajax({
// //     type: 'POST',
// //     url: '/cart/add.js',
// //     data:{
// //       id: get_id,
// //       quantity: 1,
// //     },
// //     dataType: 'json',
// //     beforeSend: function() {
// //     },
// //     success: function(get_id){
// //       console.log('working');
// //         // getCartHtml();
// //         // getmainCartHtml();
      
// //       if (window.location.href.indexOf("cart") > -1) {
// //         new_getCartHtml();
// //       }else{
// //         new_getmainCartHtml();
// //       }
// //     },
// //   });
// // });

// // function new_getmainCartHtml() {
  
// //   jQuery.ajax({
// //     type: 'GET',
// //     url: '/',
// //     dataType: 'html',
// //     success: function(cart){ 
// //       $('.mini-cart').html($(cart).find('.mini-cart').html());
// //       $('.header__cart-count').html($(cart).find('.header__cart-count').text());
// //         // $('.new-sale-product-wraper').slick({
// //         //   infinite: true,
// //         //   slidesToShow: 1,
// //         //   slidesToScroll: 1,
// //         //   dots:false,
// //         //   arrows:true
// //         // });
// //       if($('.cart-offer-product-wraper').hasClass('gift-product-custom-class-main')){
// //         var get_product_id = $('.cart-offer-product-wraper').find('.offer-product-addtocart').data('id');
// //         console.log(get_product_id);
// //           console.log('checking custom 2--'+get_product_id);
// //         jQuery.ajax({  
// //           type: 'POST',
// //           url: '/cart/add.js',
// //           data:{
// //             id: get_product_id,
// //             quantity: 1
// //           },
// //           dataType: 'json',
// //           success: function(productid){
// //             jQuery.ajax({
// //               type: 'GET',
// //               url: '/',
// //               dataType: 'html',
// //               success: function(cart){ 
// //                 $('.mini-cart').html($(cart).find('.mini-cart').html());
// //                 $('.header__cart-count').html($(cart).find('.header__cart-count').text());
// //                 $('.new-sale-product-wraper').slick({
// //                 infinite: true,
// //                 slidesToShow: 1,
// //                 slidesToScroll: 1,
// //                 dots:false,
// //                 arrows:true
// //               });
// //                 custom_offers();
// //                 console.log('---1');
// //               },
// //             });    
// //           },
// //           error: function () {
// //                 custom_offers();
// //                 console.log('checking testing');
// //           }
// //         });                               
// //       }
// //       var productid = $('.offer-product-item-id-remove').val();
// //       if(productid != undefined){
// //         jQuery.ajax({  
// //           type: 'POST',
// //           url: '/cart/change.js',
// //           data:{
// //             id: productid,
// //             quantity: 0
// //           },
// //           dataType: 'json',
// //           success: function(productid){
// //             jQuery.ajax({
// //               type: 'GET',
// //               url: '/',
// //               dataType: 'html',
// //               success: function(cart){ 
// //                 $('.mini-cart').html($(cart).find('.mini-cart').html());
// //                 $('.header__cart-count').html($(cart).find('.header__cart-count').text());
// //                 $('.new-sale-product-wraper').slick({
// //                   infinite: true,
// //                   slidesToShow: 1,
// //                   slidesToScroll: 1,
// //                   dots:false,
// //                   arrows:true
// //                 });
// //                 custom_offers();
// //                 console.log('---2');
// //               },
// //             });    
// //           },
// //           error: function () {
// //                 custom_offers();
// //                 console.log('checking testing 2');
// //           }
// //         });  
// //       }else{
// //         $('.zecpe-btn[name="checkout"]').attr('disabled',true);
// //       }
// //     },
// //   });
// // }

// function new_getCartHtml(){
//   jQuery.ajax({
//     type: 'GET',
//     url: '/cart',
//     dataType: 'html',
//     success: function(cart){
//       console.log('working section new_getCartHtml');
//       $('.cart-section-custom-swaper').html($(cart).find('.cart-section-custom-swaper').html());
//       $('.header__cart-count').html($(cart).find('.header__cart-count').text());
//        $('.zecpe-btn[name="checkout"]').removeClass('custom-stop-event');
//         //       $('.new-sale-product-wraper').slick({
//         //   infinite: true,
//         //   slidesToShow: 1,
//         //   slidesToScroll: 1,
//         //   dots:false,
//         //   arrows:true
//         // });
//       if($('.cart-offer-product-wraper').hasClass('gift-product-custom-class-main')){
//         var get_product_id = $('.cart-offer-product-wraper').find('.offer-product-addtocart').data('id');
//         console.log(get_product_id);
//         if(get_product_id != ''){
//           console.log('checking custom 2--'+get_product_id);
//         jQuery.ajax({  
//           type: 'POST',
//           url: '/cart/add.js',
//           data:{
//             id: get_product_id,
//             quantity: 1
//           },
//           dataType: 'json',
//           success: function(productid){
//             jQuery.ajax({
//               type: 'GET',
//               url: '/cart',
//               dataType: 'html',
//               success: function(cart){ 
//                 $('.cart-section-custom-swaper').html($(cart).find('.cart-section-custom-swaper').html());
//                 $('.header__cart-count').html($(cart).find('.header__cart-count').text());
//                 custom_offers();
//               //   $('.new-sale-product-wraper').slick({
//               //   infinite: true,
//               //   slidesToShow: 1,
//               //   slidesToScroll: 1,
//               //   dots:false,
//               //   arrows:true
//               // });
//               },
//             });    
//           },
//           error: function () {
//                 custom_offers();
//                 console.log('checking testing');
//           }
//         });  
//         }else{
//           custom_offers();
//           console.log('working blank');
//         }
//       }
//       var productid = $('.offer-product-item-id-remove').val();
//       if(productid != undefined){
//         jQuery.ajax({  
//           type: 'POST',
//           url: '/cart/change.js',
//           data:{
//             id: productid,
//             quantity: 0
//           },
//           dataType: 'json',
//           success: function(productid){
//             jQuery.ajax({
//               type: 'GET',
//               url: '/',
//               dataType: 'html',
//               success: function(cart){ 
//               $('.cart-section-custom-swaper').html($(cart).find('.cart-section-custom-swaper').html());
//               $('.header__cart-count').html($(cart).find('.header__cart-count').text());
//                 $('.new-sale-product-wraper').slick({
//                   infinite: true,
//                   slidesToShow: 1,
//                   slidesToScroll: 1,
//                   dots:false,
//                   arrows:true
//                 });
//                 custom_offers();
//                                 console.log('---6');
//               },
//             });    
//           }
//         });  
//       }
//     }
//   });
// }

// function getCartHtml(){
//   jQuery.ajax({
//     type: 'GET',
//     url: '/',
//     dataType: 'html',
//     success: function(cart){ 
//       $('.mini-cart').html($(cart).find('.mini-cart').html());
//       $('.header__cart-count').html($(cart).find('.header__cart-count').text());
//       console.log('mini cart html');
//         $('.new-sale-product-wraper').slick({
//           infinite: true,
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           dots:false,
//           arrows:true
//         });
//       custom_offers();
//       console.log('---3');
//       if($('.cart-offer-product-wraper').hasClass('gift-product-custom-class-main')){
//         var get_product_id = $('.cart-offer-product-wraper').find('.offer-product-addtocart').data('id');
//         console.log(get_product_id);
//           console.log('checking custom 2--'+get_product_id);
//         jQuery.ajax({  
//           type: 'POST',
//           url: '/cart/add.js',
//           data:{
//             id: get_product_id,
//             quantity: 1
//           },
//           dataType: 'json',
//           success: function(productid){
//             jQuery.ajax({
//               type: 'GET',
//               url: '/',
//               dataType: 'html',
//               success: function(cart){ 
//                 $('.mini-cart').html($(cart).find('.mini-cart').html());
//                 $('.header__cart-count').html($(cart).find('.header__cart-count').text());
//                 $('.new-sale-product-wraper').slick({
//                 infinite: true,
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 dots:false,
//                 arrows:true
//               });
//                 custom_offers();
//                                 console.log('---4');
//               },
//             });    
//           },
//           error:function(err){
//             custom_offers();
//           }
//         });                               
//       }
//       var productid = $('.offer-product-item-id-remove').val();
//       if(productid != undefined){
//         jQuery.ajax({  
//           type: 'POST',
//           url: '/cart/change.js',
//           data:{
//             id: productid,
//             quantity: 0
//           },
//           dataType: 'json',
//           success: function(productid){
//             jQuery.ajax({
//               type: 'GET',
//               url: '/',
//               dataType: 'html',
//               success: function(cart){ 
//                 $('.mini-cart').html($(cart).find('.mini-cart').html());
//                 $('.header__cart-count').html($(cart).find('.header__cart-count').text());
//                 $('.new-sale-product-wraper').slick({
//                   infinite: true,
//                   slidesToShow: 1,
//                   slidesToScroll: 1,
//                   dots:false,
//                   arrows:true
//                 });
//                 custom_offers();
//                                 console.log('---5');
//               },
//             });    
//           }
//         });  
//       }
//     },
//   });
// }
// function getmainCartHtml(){
//   jQuery.ajax({
//     type: 'GET',
//     url: '/cart',
//     dataType: 'html',
//     success: function(cart){
//       $('.cart-section-custom-swaper').html($(cart).find('.cart-section-custom-swaper').html());
//       $('.header__cart-count').html($(cart).find('.header__cart-count').text());
//       $('.zecpe-btn[name="checkout"]').removeClass('custom-stop-event');
//     }
//   });

// // console.log('working cart mini');
// //     jQuery.ajax({
// //     type: 'GET',
// //     url: '/cart',
// //     dataType: 'html',
// //     success: function(cart){ 
// //       $('.cart-section-custom-swaper').html($(cart).find('.cart-section-custom-swaper').html());
// //       $('.header__cart-count').html($(cart).find('.header__cart-count').text());
      
// //       if($('.cart-offer-product-wraper').hasClass('gift-product-custom-class-main')){
// //         var get_product_id = $('.cart-offer-product-wraper').find('.offer-product-addtocart').data('id');
// //         console.log(get_product_id);
// //          console.log('checking custom 1--'+get_product_id);
// //         jQuery.ajax({  
// //           type: 'POST',
// //           url: '/cart/add.js',
// //           data:{
// //             id: get_product_id,
// //             quantity: 1
// //           },
// //           dataType: 'json',
// //           success: function(productid){
// //             jQuery.ajax({
// //               type: 'GET',
// //               url: '/',
// //               dataType: 'html',
// //               success: function(cart){ 
// //                 $('.cart-section-custom-swaper').html($(cart).find('.cart-section-custom-swaper').html());
// //                 $('.header__cart-count').html($(cart).find('.header__cart-count').text());
// //               },
// //             });    
// //           }
// //         });                               
// //       }
// //       var productid = $('.offer-product-item-id-remove').val();
// //       if(productid != undefined){
// //         jQuery.ajax({  
// //           type: 'POST',
// //           url: '/cart/change.js',
// //           data:{
// //             id: productid,
// //             quantity: 0
// //           },
// //           dataType: 'json',
// //           success: function(productid){
// //             jQuery.ajax({
// //               type: 'GET',
// //               url: '/',
// //               dataType: 'html',
// //               success: function(cart){ 
// //                 $('.cart-section-custom-swaper').html($(cart).find('.cart-section-custom-swaper').html());
// //                 $('.header__cart-count').html($(cart).find('.header__cart-count').text());
// //               },
// //             });    
// //           }
// //         });  
// //       }

// //     },
// //   });
  
  
// }

// var show_twice_count = localStorage.getItem('show_twice');
// if(show_twice_count == 'unset_popup'){
//   console.log('allset');
// }else{
//   if(show_twice_count == '1'){
//     localStorage.setItem('show_twice', '2');
//     if($('.theme-popup-content-wraper').hasClass('show_twice-popup-to_user')){
//       var timeoutfunction = $('.show_twice-popup-to_user').data('apparitiondelay');
//       setTimeout(function(){ 
//         $('.show_twice-popup-to_user').attr('aria-hidden',false);
//       }, timeoutfunction);
//     }
//   }else if(show_twice_count == '2'){
//     localStorage.setItem('show_twice', 'unset_popup');
//   }else{
//     localStorage.setItem('show_twice', '1');
//     if($('.theme-popup-content-wraper').hasClass('show_twice-popup-to_user')){
//       var timeoutfunction = $('.show_twice-popup-to_user').data('apparitiondelay');
//       setTimeout(function(){ 
//         $('.show_twice-popup-to_user').attr('aria-hidden',false);
//       }, timeoutfunction);
//     }
//   }
// }


// var pro_rating_star =  $('.product-meta').find('.stamped-product-reviews-badge .stamped-badge').data('rating');
// var pro_no_review =  $('.product-meta').find('.stamped-product-reviews-badge .stamped-badge .stamped-badge-caption').data('reviews');
// if(pro_no_review != undefined){
//   $('.product-meta').find('.stamped-product-reviews-badge .stamped-badge').html('<span Class="custom-rating-button">'+pro_rating_star+'<span><svg xmlns="http://www.w3.org/2000/svg" width="13" height="12"><path fill="#FFF" d="M6.5 9.439l-3.674 2.23.94-4.26-3.21-2.883 4.254-.404L6.5.112l1.69 4.01 4.254.404-3.21 2.882.94 4.26z"/></svg></span></span>('+pro_no_review+')');
//   $('.stamped-product-reviews-badge').show();
//   $('.stamped-product-reviews-badge').css('visibility','visible');
// }

// $(document).ready(function() {
//   var pro_rating_star =  $('.product-meta').find('.stamped-product-reviews-badge .stamped-badge').data('rating');
//   var pro_no_review =  $('.product-meta').find('.stamped-product-reviews-badge .stamped-badge .stamped-badge-caption').data('reviews');
//   if(pro_no_review != undefined){
//     $('.product-meta').find('.stamped-product-reviews-badge .stamped-badge').html('<span Class="custom-rating-button">'+pro_rating_star+'<span><svg xmlns="http://www.w3.org/2000/svg" width="13" height="12"><path fill="#FFF" d="M6.5 9.439l-3.674 2.23.94-4.26-3.21-2.883 4.254-.404L6.5.112l1.69 4.01 4.254.404-3.21 2.882.94 4.26z"/></svg></span></span>('+pro_no_review+')');
//     $('.stamped-product-reviews-badge').show();
//     $('.stamped-product-reviews-badge').css('visibility','visible');
//   }

//   setTimeout(function(){
//     var pro_rating_star =  $('.product-meta').find('.stamped-product-reviews-badge .stamped-badge').data('rating');
//     var pro_no_review =  $('.product-meta').find('.stamped-product-reviews-badge .stamped-badge .stamped-badge-caption').data('reviews');
//     if(pro_no_review != undefined){
//       $('.product-meta').find('.stamped-product-reviews-badge .stamped-badge').html('<span Class="custom-rating-button">'+pro_rating_star+'<span><svg xmlns="http://www.w3.org/2000/svg" width="13" height="12"><path fill="#FFF" d="M6.5 9.439l-3.674 2.23.94-4.26-3.21-2.883 4.254-.404L6.5.112l1.69 4.01 4.254.404-3.21 2.882.94 4.26z"/></svg></span></span>('+pro_no_review+')');
//       $('.stamped-product-reviews-badge').show();
//       $('.stamped-product-reviews-badge').css('visibility','visible');
//     }
//   },3000); 
// });
// $(document).on('click','.product-gallery__thumbnail .aspect-ratio img',function(){
//   var value= $(this).parents('.product-gallery__thumbnail').find('.variant_class').attr('data-variant');
//   console.log(value);
//   $('.color-swatch input').each(function(){
//     var value2 = $(this).val();

//     if(value==value2){
//       var new_val = $(this).attr('data-name');
//       $(this).parents('.product-form__option').find('.product-form__option-name .product-form__selected-value-custom-text-append').text(new_val);

//       $(this).trigger("click");
//     }
//   });
//   $('.block-swatch input').each(function(){
//     var value3 = $(this).val();

//     if(value==value3){
//       var new_val = $(this).attr('data-name');
//       $(this).parents('.product-form__option').find('.product-form__option-name .product-form__selected-value-custom-text-append').text(new_val);

//       $(this).trigger("click");
//     }
//   }); 
// });

// $(".product-gallery__carousel-wrapper").on( 'change.flickity', function( event, index ) {
//   var value= $(".product-gallery__thumbnail.is-nav-selected .variant_class").attr('data-variant');
//   $('.color-swatch input').each(function(){
//     var value2 = $(this).val();

//     if(value==value2){
//       var new_val = $(this).attr('data-name');
//       $(this).parents('.product-form__option').find('.product-form__option-name .product-form__selected-value-custom-text-append').text(new_val);

//       $(this).trigger("click");
//     }
//   });
//   $('.block-swatch input').each(function(){
//     var value3 = $(this).val();

//     if(value==value3){
//       var new_val = $(this).attr('data-name');
//       $(this).parents('.product-form__option').find('.product-form__option-name .product-form__selected-value-custom-text-append').text(new_val);

//       $(this).trigger("click");
//     }
//   }); 
// });

$(document).ready(function(){
  
      $(document).on('change','.main-option-value-select-box',function(){
    var getimage_url= $(this).find(':selected').attr('data-image');
        var getsku= $(this).find(':selected').attr('data-sku');
                var getprice= $(this).find(':selected').attr('data-price');
          var line_prop = getsku+  "/" + getprice + "/" + "1" ;
          $(this).parents('.infinity_options_custom').find('input.combo-product-linemain_prop').val(line_prop);
    if(getimage_url !=''){
      $(this).parents('.infinity_options_custom').find('.select_your_shade').html("<img class='roll' src='" + getimage_url + "'>");

    }
    else{
      $(this).parents('.infinity_options_custom').find('.select_your_shade').html("SELECT YOUR SHADE");

    }
    console.log(getimage_url);
    var value_get = $(this).val();
    if(value_get == 'Select Your Shade'){
      $(this).addClass('not-selected');
      $(this).removeClass('option-selected');
    }else{
      $(this).removeClass('not-selected');
      $(this).addClass('option-selected');
    }
    $(this).parents('.spb-select').find('.second-option-value-select-box option[data-val="'+value_get+'"]').prop('selected', true);

  });

  $(document).on("click","button.btn.cart__checkout.main-remove-care-plan_btn",function(event){
  event.preventDefault();
    $("div#free-gift-offer .add_to_cart").css('opacity','0.5');
$("div#free-gift-offer .add_to_cart").css('pointer-events','none');
  var rand = $(this).attr("data-random");
    var $this = $(this);
 $this.parents('tr.cart-item').find('.loading-overlay').removeClass('hidden');
   jsonObj = [];
  $(".random_number_generator").each(function() {
    var data = $(this).attr("data-input-index");
    var qty = $(this).attr("data-quantity");
    var current = $(this).val();
    if (current == rand) {
      jsonObj.push(0);
    }
    else{
      jsonObj.push(qty);
    }
  });
console.log(jsonObj);
   $.ajax({
     url: '/cart/update.js',
     type: "POST",
     data :{updates: jsonObj},
     dataType: "json",
     success: function(data) {
       $.ajax({
         url: window.location.href,
         type: "GET",
         dataType: "html",
         success: function(data) {
           $('.some_js_items').html($(data).find('.some_js_items').html());
            $("form#MainCartDrawer").html($(data).find('form#MainCartDrawer').html());
            $(".header-cart-icon__count").html($(data).find('.header-cart-icon__count').html());
            var check_if_remove = $(".remove_gift_product").val();
            var get_total_price = $("loess-cart-drawer-checkout#CartDrawerTotalPrice").attr('data-price');
            var get_thresold =  $("loess-cart-drawer-checkout#CartDrawerTotalPrice").attr('data-left');
if(check_if_remove == 'yes' || get_total_price <= get_thresold){
    $("tr.free_gift_pdp.cart-item loess-cart-remove-button.remove__button").trigger('click');

}

           $('.combo-product-lineitemno').html($(data).find('.combo-product-lineitemno').html());

         },

       });
      
      //  getCartHtml();
     
       // getmainCartHtml();
      
     },
     error: function(jqxhr, textStatus, error) {

     }
   });   
 



});


  $(document).ready(function(){
    var curr= $('.get-product-id-for-combo').attr("data-check");
    if((curr != undefined)&&(curr != '')){
      var myArr = curr.split(",");
      var jsonobj = [];
      for (let i = 0; i < myArr.length; i++) {
        if(myArr[i] != ''){
          jsonobj.push(parseInt(myArr[i]));
        }
      }
      jQuery.post('/cart/update.js', {updates:jsonobj}).done(function() {
          
            getCartHtml();
        
            getmainCartHtml();
          
      });
    }
  });
 
});



$(document).on('click','.free-combo-product-gift', function(){
  localStorage.setItem("free-product", "remove");
});
$(document).ready(function(){
  jQuery.ajax({
    type: 'GET',
    url: '/cart',
    dataType: 'json',
    success: function(cart){
      if(cart.item_count == 0){
        localStorage.removeItem("free-product");
      }
    },
  }); 
});


// jQuery(document).ready(function() {
//   addDiscountsummary();
// });

// function addDiscountsummary() {
//   setTimeout(function() {

//     if ($('div#scm-reviews-importer').is(':visible')) {
//       var  get_height=   $("div#scm-reviews-importer").height();

//       get_height = get_height-120;
//       $("div#scm-reviews-importer").height(get_height);
//     }
//   }, 3000);  
// }
// var existCondition = setInterval(function() {
//  if ($('#scm-reviews-importer').length) {
//  var  get_height=   $("div#scm-reviews-importer").height();

//       get_height = get_height-70;
//       $("div#scm-reviews-importer").height(get_height);
//     clearInterval(existCondition);
//     doTheRestOfTheStuff(parameters);
//  }
// }, 4000); // check every 100ms
function first_box(){
 var get_value =$(".first_bundle li:eq(0)").attr('value');
  $('.first_box')
  .val(get_value)
  .trigger('change');
  var get_html = $(".first_box option:selected").val();
  $(".selected_color_title").html(get_html);
  $(".first_bundle li:eq(0)").addClass('active');  
  
}

$(document).ready(function(){
 first_box();
});

  $(document).on('click','.first_bundle li', function(){

  $(".first_bundle li").removeClass('active');  
  var get_value = $(this).attr('value');
  $('.first_box')
  .val(get_value)
  .trigger('change');
  var get_html = $(".first_box option:selected").val();
  $(".selected_color_title").html(get_html);
  $(this).addClass('active');  

});
function first_box2(){
 var get_value =$(".first_bundle2 li:eq(0)").attr('value');
  $('.first_box2')
  .val(get_value)
  .trigger('change');
  var get_html = $(".first_box2 option:selected").val();
  $(".selected_color_title2").html(get_html);
  $(".first_bundle2 li:eq(0)").addClass('active'); 
}
$(document).ready(function(){
  
first_box2();
});
  $(document).on('click','.first_bundle2 li', function(){
  $(".first_bundle2 li").removeClass('active');  

  var get_value = $(this).attr('value');
  $('.first_box2')
  .val(get_value)
  .trigger('change');
  var get_html = $(".first_box2 option:selected").val();
  $(".selected_color_title2").html(get_html);
  $(this).addClass('active');  

});
function first_box3(){
   var get_value =$(".first_bundle3 li:eq(0)").attr('value');
  $('.first_box3')
  .val(get_value)
  .trigger('change');
  var get_html = $(".first_box3 option:selected").val();
  $(".selected_color_title3").html(get_html);
  $(".first_bundle3 li:eq(0)").addClass('active');     
}
$(document).ready(function(){
first_box3();
});
  $(document).on('click','.first_bundle3 li', function(){
  $(".first_bundle3 li").removeClass('active');  

  var get_value = $(this).attr('value');
  $('.first_box3')
  .val(get_value)
  .trigger('change');
  var get_html = $(".first_box3 option:selected").val();
  $(".selected_color_title3").html(get_html);
  $(this).addClass('active');  
});
function first_box4(){
 var get_value =$(".first_bundle4 li:eq(0)").attr('value');
  $('.first_box4')
  .val(get_value)
  .trigger('change');
  var get_html = $(".first_box4 option:selected").val();
  $(".selected_color_title4").html(get_html);
  $(".first_bundle4 li:eq(0)").addClass('active');  
}
$(document).ready(function(){
 first_box4();
});
  $(document).on('click','.first_bundle4 li', function(){
  $(".first_bundle4 li").removeClass('active');  

  var get_value = $(this).attr('value');
  $('.first_box4')
  .val(get_value)
  .trigger('change');
  var get_html = $(".first_box4 option:selected").val();
  $(".selected_color_title4").html(get_html);
  $(this).addClass('active');  
});
function first_box5(){
   var get_value =$(".first_bundle5 li:eq(0)").attr('value');
  $('.first_box5')
  .val(get_value)
  .trigger('change');
  var get_html = $(".first_box5 option:selected").val();
  $(".selected_color_title5").html(get_html);
  $(".first_bundle5 li:eq(0)").addClass('active');  
}

$(document).ready(function(){
 first_box5();

});
  $(document).on('click','.first_bundle5 li', function(){
  $(".first_bundle5 li").removeClass('active');  

  var get_value = $(this).attr('value');
  $('.first_box5')
  .val(get_value)
  .trigger('change');
  var get_html = $(".first_box5 option:selected").val();
  $(".selected_color_title5").html(get_html);
  $(this).addClass('active');  

});
function first_box6(){
   var get_value =$(".first_bundle6 li:eq(0)").attr('value');
  $('.first_box6')
  .val(get_value)
  .trigger('change');
  var get_html = $(".first_box6 option:selected").val();
  $(".selected_color_title6").html(get_html);
  $(".first_bundle6 li:eq(0)").addClass('active');  

}  

$(document).ready(function(){
 first_box6();
});
  $(document).on('click','.first_bundle6 li', function(){
  $(".first_bundle6 li").removeClass('active');  

  var get_value = $(this).attr('value');
  $('.first_box6')
  .val(get_value)
  .trigger('change');
  var get_html = $(".first_box6 option:selected").val();
  $(".selected_color_title6").html(get_html);
  $(this).addClass('active');  

});
function first_box7(){
   var get_value =$(".first_bundle7 li:eq(0)").attr('value');
  $('.first_box7')
  .val(get_value)
  .trigger('change');
  var get_html = $(".first_box7 option:selected").val();
  $(".selected_color_title7").html(get_html);
  $(".first_bundle7 li:eq(0)").addClass('active');
}
$(document).ready(function(){
   first_box7();

});
  $(document).on('click','.first_bundle7 li', function(){
  $(".first_bundle7 li").removeClass('active');  

  var get_value = $(this).attr('value');
  $('.first_box7')
  .val(get_value)
  .trigger('change');
  var get_html = $(".first_box7 option:selected").val();
  $(".selected_color_title7").html(get_html);
  $(this).addClass('active');  

});
function first_box8(){
  var get_value =$(".first_bundle8 li:eq(0)").attr('value');
  $('.first_box8')
  .val(get_value)
  .trigger('change');
  var get_html = $(".first_box8 option:selected").val();
  $(".selected_color_title8").html(get_html);
  $(".first_bundle8 li:eq(0)").addClass('active');  
}
$(document).ready(function(){
first_box8();

});
  $(document).on('click','.first_bundle8 li', function(){
  $(".first_bundle8 li").removeClass('active');  

  var get_value = $(this).attr('value');
  $('.first_box8')
  .val(get_value)
  .trigger('change');
  var get_html = $(".first_box8 option:selected").val();
  $(".selected_color_title8").html(get_html);
  $(this).addClass('active');  

});
$(window).on('scroll', function() {
  var $addToCartButton = $(".shopify-section--main-product button.add-to-cart-button");

  // Check if the element exists before using .offset()
  if ($addToCartButton.length === 0) {
    // Optional: skip or log a warning
    console.warn("Add to Cart button not found");
    return;
  }

  var topcart = $addToCartButton.offset().top;
  var showAfterc = topcart;

  if ($(this).scrollTop() > showAfterc) {
    $("body").addClass('sticky_add_to_cart');
  } else {
    $("body").removeClass('sticky_add_to_cart');
  }
});

//   $(".trigger_popup_fricc2").click(function(){
//     var get_handle= $(this).attr('data-handle');
//     var get_url= $(this).attr('data-url');
// //     alert(get_url);
//     $.ajax({
//       url: get_url,
//       type: "GET",
//       dataType: "html",
//       success: function(data) {
// $(".loader_gif").hide();
//         $('.product_1_wrapper').html($(data).find('div#shopify-section-product-template').html());


//         first_box();
//         first_box2();
//         first_box3();
//         first_box4();
//         first_box5();
//         first_box6();
//         first_box7();
//         first_box8();
//       },
//     });
//   });
//        $('.hover_bkgr_fricc2').show();
// 		$(".css-1swvniq").addClass('hide');
//        $('.hover_bkgr_fricc2').addClass('active');
   
   
  //   $('.popupCloseButton').click(function(){
  //       $('.hover_bkgr_fricc2').hide();
		// $(".css-1swvniq").removeClass('hide');

  //      $('.hover_bkgr_fricc2').removeClass('active');
  //     $('.hover_bkgr_fricc2 .product_1_wrapper').html('');

  //   });

   // $('.hover_bkgr_fricc2').click(function(e){
   //   if (!$(e.target).closest('.product_1_wrapper').length) {
   //     $(".hover_bkgr_fricc2").css("display","none");
   //     $('.hover_bkgr_fricc2 .product_1_wrapper').html('');
   //   };
   // });

// $(document).on('click','.product-form__add-button ', function(e){
//   $(".hover_bkgr_fricc2").css("display","none");
//   $('.hover_bkgr_fricc2 .product_1_wrapper').html('');
// });


    $(document).on("change",".modal__inner-dynamic-content .input__list input",function() {

                setTimeout(function() {
var get_price = $(".modal__inner-dynamic-content .prd_count.price-details").attr('data-price');
if(get_price > 20000){
    $(".modal__inner-dynamic-content .main-product__block-buy-buttons").removeClass('no_checkout_cccc');
}else{

        $(".modal__inner-dynamic-content .main-product__block-buy-buttons").addClass('no_checkout_cccc');

}
                }, 1000);
    
});
    $(document).on("change","section.shopify-section.shopify-section--main-product",function() {

                setTimeout(function() {
var get_price = $("section.shopify-section.shopify-section--main-product .prd_count.price-details").attr('data-price');
if(get_price > 20000){
    $("section.shopify-section.shopify-section--main-product .main-product__block-buy-buttons").removeClass('no_checkout_cccc');
}else{

        $("section.shopify-section.shopify-section--main-product .main-product__block-buy-buttons").addClass('no_checkout_cccc');

}
                }, 1000);
    
});
